import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { ShieldAlert, Trash2 } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

/**
 * Danger zone: permanent account delete with a "type DELETE to confirm" gate.
 */
const CustomerDangerZone = ({ authClient, onDeleted }) => {
  const { toast } = useToast();
  const [show, setShow] = useState(false);
  const [confirm, setConfirm] = useState('');

  const onDelete = async () => {
    if (confirm.trim().toUpperCase() !== 'DELETE') {
      return toast({ title: 'Type DELETE in capital letters to confirm', variant: 'destructive' });
    }
    try {
      await authClient.delete('/auth/me');
      toast({ title: 'Account deleted' });
      onDeleted && onDeleted();
    } catch (err) {
      toast({ title: 'Delete failed', description: err?.response?.data?.detail || err.message, variant: 'destructive' });
    }
  };

  return (
    <div className="bg-white border-2 border-red-200 rounded-md p-6" data-testid="customer-danger-zone">
      <h3 className="text-base font-semibold text-red-700 flex items-center gap-2 mb-1">
        <ShieldAlert className="w-5 h-5" /> Delete My Account
      </h3>
      <p className="text-xs text-gray-600 mb-4">Permanently delete your TelanganaMart account. Your enquiries and posted requirements will be preserved for vendors who already received them, but you&apos;ll lose access.</p>

      {!show ? (
        <Button variant="outline" onClick={() => setShow(true)} className="text-red-600 border-red-300 hover:bg-red-50" data-testid="profile-show-delete-btn">
          <Trash2 className="w-4 h-4 mr-2" /> Delete my account
        </Button>
      ) : (
        <div className="space-y-3 bg-red-50 border border-red-200 rounded p-3">
          <p className="text-sm text-red-800 font-medium">Type <b className="bg-white px-1.5 py-0.5 rounded border border-red-300 font-mono">DELETE</b> to confirm:</p>
          <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="DELETE" className="bg-white max-w-xs" data-testid="profile-delete-confirm" />
          <div className="flex gap-2">
            <Button onClick={onDelete} className="bg-red-600 hover:bg-red-700 text-white" data-testid="profile-delete-btn">
              <Trash2 className="w-4 h-4 mr-2" /> Permanently delete
            </Button>
            <Button variant="outline" onClick={() => { setShow(false); setConfirm(''); }} data-testid="profile-cancel-delete-btn">
              Cancel
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerDangerZone;
